// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3SeE_","App-logo":"App_App-logo__uMDlf","App-logo-spin":"App_App-logo-spin__251DS","App-header":"App_App-header__221bU","App-link":"App_App-link__mtH2y"};